import { render } from "./create-customer.vue?vue&type=template&id=afb04df8&scoped=true"
import script from "./create-customer.vue?vue&type=script&lang=js"
export * from "./create-customer.vue?vue&type=script&lang=js"

import "./create-customer.vue?vue&type=style&index=0&id=afb04df8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb04df8"]])

export default __exports__